import { useEffect, useRef, useState } from "react";
import { useAuth } from "../context/Auth";
import { reducedMotion, eur, wa, WA_DISPLAY } from "../lib/fmt";

export function BrandMark({ big = false, testid = "brand" }) {
  const { config } = useAuth();
  const name = (config.brand_name || "CRIPTO CLUB").trim();
  const src = config.logo_url || "/logo.png";
  return <div className={big ? "auth-logo-full" : "brand-full"} data-testid={testid}><img src={src} alt={name} /></div>;
}

export function WaFloat() {
  return (
    <a className="wa-float" href={wa()} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-btn" aria-label={`Soporte por WhatsApp ${WA_DISPLAY}`}>
      💬 <span>WhatsApp</span>
    </a>
  );
}

export function CountUp({ value, money = true, testid }) {
  const [shown, setShown] = useState(value || 0);
  const [pop, setPop] = useState(false);
  const prev = useRef(value || 0);
  useEffect(() => {
    const from = prev.current, to = Number(value || 0);
    prev.current = to;
    if (from === to || reducedMotion()) { setShown(to); return; }
    setPop(true);
    const start = performance.now(), dur = 900;
    let raf;
    const step = (t) => {
      const k = Math.min(1, (t - start) / dur);
      setShown(from + (to - from) * (1 - Math.pow(1 - k, 3)));
      if (k < 1) raf = requestAnimationFrame(step); else setTimeout(() => setPop(false), 300);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  return <span className={pop ? "count-pop" : ""} data-testid={testid}>{money ? eur(shown) : Math.round(shown).toLocaleString("es-ES")}</span>;
}

export function Bar({ pct, small = false, testid }) {
  const [w, setW] = useState(0);
  useEffect(() => { const t = setTimeout(() => setW(Math.max(0, Math.min(100, pct || 0))), 60); return () => clearTimeout(t); }, [pct]);
  return (
    <div className={`progress-track ${small ? "progress-small" : ""}`} role="progressbar" aria-valuenow={Math.round(w)} aria-valuemin={0} aria-valuemax={100} data-testid={testid}>
      <div className="progress-fill" style={{ width: `${w}%` }} />
    </div>
  );
}

export function Micro({ pct }) {
  return <div className="microtrack"><div style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} /></div>;
}

export function DemoMark() {
  return null;
}

export function CookieBar() {
  const [show, setShow] = useState(!localStorage.getItem("cc_cookies"));
  if (!show) return null;
  return (
    <div className="cookie-bar" data-testid="cookie-banner">
      <span style={{ flex: 1 }}>🍪 Solo usamos cookies técnicas necesarias para mantener tu sesión segura. No usamos cookies publicitarias. <a href="/legal/cookies" style={{ color: "#9cf0b4", fontWeight: 800 }}>Más información</a></span>
      <button className="primary" data-testid="cookie-accept-btn" onClick={() => { localStorage.setItem("cc_cookies", "ok"); setShow(false); }}>Entendido</button>
    </div>
  );
}

export function LegalLinks() {
  const items = [["terminos", "Términos de uso"], ["privacidad", "Privacidad"], ["cookies", "Cookies"], ["premios", "Condiciones de premios y retiradas"], ["comisiones", "Comisiones"], ["riesgos", "Riesgos cripto"], ["contacto", "Contacto"]];
  return <div className="foot-links">{items.map(([k, l]) => <a key={k} href={`/legal/${k}`} data-testid={`legal-link-${k}`}>{l}</a>)}</div>;
}

export function Spinner() {
  return <div className="loading-screen"><span className="spin" aria-label="Cargando" /></div>;
}
